import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Router } from "@angular/router";

import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";

import { Discussion } from "../../../../models";
import { BookmarkService, UserService } from "../../../../services";

@Component({
  selector: "bookmark-discussion-button",
  templateUrl: "./bookmark-discussion-button.component.html",
  styleUrls: [
    "./bookmark-discussion-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class BookmarkDiscussionButtonComponent {
  @Input() discussion: Discussion;
  @Output() onToggle = new EventEmitter<boolean>();
  public isSubmitting = false;

  constructor(
    private bookmarkService: BookmarkService,
    private router: Router,
    private userService: UserService
  ) {
    this.initializePNotify();
  }

  ngOnInit() {}

  public bookmarkDiscussion() {
    this.isSubmitting = true;

    this.userService.isAuthenticated.subscribe((authenticated) => {
      // Not authenticated? Push to login screen
      if (!authenticated) {
        this.router.navigateByUrl("/login");
        return;
      }

      // Bookmark the discussion if it isn't bookmark yet
      if (this.discussion.bookmarked !== null && !this.discussion.bookmarked) {
        this.bookmarkService.updateOne(this.discussion.slug).subscribe(
          (data) => {
            this.isSubmitting = false;
            this.onToggle.emit(true);
            this.notifyUser();
          },
          (err) => (this.isSubmitting = false)
        );
        // Otherwise,reverse the bookmark of the discussion
      } else {
        this.bookmarkService.updateOne(this.discussion.slug).subscribe(
          (data) => {
            this.isSubmitting = false;
            this.onToggle.emit(false);
            this.notifyUser();
          },
          (err) => (this.isSubmitting = false)
        );
      }
    });
  }

  public initializePNotify() {
    PNotifyButtons; // Initiate the module. Important!
    PNotify.defaults.styling = "bootstrap4"; // Bootstrap version 4
    PNotify.defaults.icons = "fontawesome4"; // Font Awesome 4
  }

  public notifyUser() {
    PNotify.info({
      title: "Hey!",
      titleTrusted: false,
      text: this.discussion.bookmarked
        ? "Bookmark added: " + this.discussion.slug.substring(0, 50) + "..."
        : "Bookmark removed: " + this.discussion.slug.substring(0, 50) + "...",
      textTrusted: false,
      icon: "fa fa-bell",
      Mobile: {
        swipeDismiss: true,
        styling: true,
      },
      width: "300px",
      delay: 3000,
      buttons: { closer: true, labels: { close: "Fechar", stick: "Manter" } },
      stack: {
        dir1: "down",
        firstpos1: 25,
      },
    });
  }
}
